import React, { FC } from 'react'
import styled from 'styled-components'

import { breakpoints } from '@ads/front-core/constants/breakpoints'
import { lng, Trans } from '@ads/front-core/locales'

export const Stay: FC = () => (
  <Content>
    <HeaderText>
      <Trans
        i18nKey="lppartners:stay.header"
        components={{
          bold: <HeaderTextBold />,
        }}
      />
    </HeaderText>
    <Text>{lng('lppartners:stay.text')}</Text>
  </Content>
)

const Content = styled.div`
  font-family: Poppins;
  max-width: 1348px;
  margin: 0 auto;
  padding: 60px 62px 80px 62px;
  color: #262a44;

  @media (max-width: ${breakpoints.MOBILE}) {
    padding: 52px 16px 60px 16px;
  }
`

const HeaderText = styled.p`
  font-size: 36px;
  font-weight: 300;
  margin-bottom: 8px;

  @media (max-width: ${breakpoints.MOBILE}) {
    font-size: 26px;
    margin-bottom: 16px;
    max-width: 250px;
  }
`

const HeaderTextBold = styled.strong`
  font-weight: 600;
`

const Text = styled.p`
  font-size: 18px;
  font-style: normal;
  font-weight: 200;
  line-height: normal;

  @media (max-width: ${breakpoints.MOBILE}) {
    font-size: 16px;
  }
`
